import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { createPortal } from "react-dom";
import GenericButton from "../helpers/GenericButton";
import useTailwindBreakpoint from "../../hooks/useTailwindBreakpoint";
export default function ShowAllLayer({ children, onClose, onReachEnd }) {
    const isLg = useTailwindBreakpoint("lg");
    const [mounted, setMounted] = React.useState(false);
    const scrollRef = React.useRef(null);
    const [isPageEnd, setIsPageEnd] = React.useState(false);
    React.useEffect(() => {
        const id = requestAnimationFrame(() => setMounted(true));
        document.body.classList.add("overflow-hidden");
        return () => {
            document.body.classList.remove("overflow-hidden");
            cancelAnimationFrame(id);
        };
    }, []);
    const handleScroll = () => {
        const el = scrollRef.current;
        if (!el)
            return;
        const percentage = (el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100;
        setIsPageEnd(percentage > 90);
    };
    React.useEffect(() => {
        if (isPageEnd && onReachEnd) {
            onReachEnd();
            setIsPageEnd(false);
        }
    }, [onReachEnd, isPageEnd]);
    return createPortal(_jsxs("div", { ref: scrollRef, onScroll: handleScroll, className: `${mounted ? "animate-in fade-in-0 duration-300" : "animate-out fade-out-0 duration-300"} supports-backdrop-filter:bg-background/60 pointer-events-auto fixed inset-0 z-49 min-h-screen min-w-screen overflow-x-hidden overflow-y-scroll py-10 backdrop-blur-lg **:no-underline md:py-16`, children: [_jsx("div", { className: "mt-4 mr-5 flex flex-row justify-end md:mr-10", children: _jsx("div", { onClick: onClose, children: _jsx(GenericButton, { variant: "close", size: isLg ? "md" : "sm", icon: true }) }) }), _jsx("div", { className: "mt-6 flex flex-row flex-wrap justify-center gap-2 md:mt-8 md:gap-4", children: children })] }), document.body);
}
